<div class="bk-page traffic">
  <header class="bk-page__head">
    <div class="bk-page__intro">
      <p class="bk-eyebrow">SMS</p>
      <h1 class="bk-page__title">API traffic</h1>
      <p class="bk-page__sub">{{ description }}</p>
    </div>

    <div class="bk-page__actions">
      @if (tab === "log") {
        <report-period [value]="days" (valueChange)="setDays($event)" />
      }
      <button type="button" class="bk-btn bk-btn--ghost" (click)="refresh()">
        <span class="bk-sym" aria-hidden="true">refresh</span>
        Refresh
      </button>
    </div>
  </header>

  <app-routing-tab class="traffic__tabs" [tabList]="tabs" />

  <div class="traffic__body">
    @if (tab === "dashboard") {
      <!-- Same dashboard head as Delivery reports: title, note, reload and full screen. -->
      <section class="dash" aria-labelledby="traffic-dash-title">
        <div class="dash__head">
          <div class="dash__intro">
            <h2 class="bk-section-title" id="traffic-dash-title">Dashboard</h2>
            <p class="dash__note">Charts from Metabase. Use the dashboard's own filters for dates.</p>
          </div>
          <div class="dash__actions">
            <button
              type="button"
              class="bk-icon-btn"
              aria-label="Reload dashboard"
              matTooltip="Reload dashboard"
              (click)="reloadDashboard()"
            >
              <span class="bk-sym" aria-hidden="true">refresh</span>
            </button>
            @if (canFullscreen) {
              <button
                type="button"
                class="bk-icon-btn"
                aria-label="Show dashboard full screen"
                matTooltip="Full screen"
                (click)="openFullscreen()"
              >
                <span class="bk-sym" aria-hidden="true">open_in_full</span>
              </button>
            }
          </div>
        </div>

        <div class="bk-panel traffic__frame">
          <metabase-embed [dashboardId]="dashboardId" [orgIdOverride]="orgId" frameTitle="API traffic dashboard" />
        </div>
      </section>
    } @else {
      <gateway-log [days]="days" [reloadKey]="reloadKey" />
    }
  </div>
</div>
